export function substituirHistoricoERecarregar(url: string) {
  window.history.replaceState(null, '', url);
  window.location.reload();
}
